import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Select from "react-select"; // Import react-select
import FilteredMultiSelect from "./FilteredMultiSelect";
import ActivityPack from "./ActivityPack";

const config = require("../config.json");

// --- Helper Constants and Functions ---
const QUEST_DIFFICULTIES = [
  { key: "easy", label: "Let" },
  { key: "medium", label: "Mellem" },
  { key: "hard", label: "Svær" },
];

const REQUIREMENT_TYPES = [
  {
    value: "completeActivityWithChoice",
    label: "Fuldfør aktivitet med specifikt valg",
  },
  {
    value: "completeActivityOnce",
    label: "Fuldfør specifik aktivitet én gang",
  },
  { value: "earnPoints", label: "Optjen X point" },
  { value: "earnCO2", label: "Spar X kg CO2" },
  { value: "reachStreak", label: "Opnå X dages streak" },
  { value: "answerQuizCorrectly", label: "Besvar X quiz spørgsmål korrekt" },
];

const initialQuestLevelState = () => ({
  points: "",
  requirements: [],
});

const initialQuestsState = () => ({
  easy: initialQuestLevelState(),
  medium: initialQuestLevelState(),
  hard: initialQuestLevelState(),
});

const createNewRequirement = (type = REQUIREMENT_TYPES[0].value) => {
  let details = {};
  switch (type) {
    case "completeActivityWithChoice":
      details = {
        activityId: "",
        choiceText_da: "",
        choiceText_en: "",
        count: 1,
      };
      break;
    case "completeActivityOnce":
      details = { activityId: "" };
      break;
    case "earnPoints":
      details = { amount: "" };
      break;
    case "earnCO2":
      details = { amount: "" };
      break;
    case "reachStreak":
      details = { days: "" };
      break;
    case "answerQuizCorrectly":
      details = { count: 1 };
      break;
    default:
      break;
  }
  return {
    id: uuid(),
    description: "",
    description_en: "",
    type: type,
    details: details,
  };
};
// --- End Helper Constants and Functions ---

export default class ActivityPackAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    newActivityPack: {
      id: uuid(),
      activities: [],
      packName: "",
      packTitle: "",
      packDescription: "",
      packTitle_en: "",
      packDescription_en: "",
      quests: initialQuestsState(),
    },
    activityPacks: [],
    activities: [],
    selectedActivities: [],
    loading: false,
  });

  handleAddActivityPack = async (activityPack, event, isCopy = false) => {
    event.preventDefault();
    try {
      const params = {
        id: uuid(),
        activities: isCopy
          ? activityPack.activities
          : this.state.selectedActivities.map((activity) => activity.id),
        packName: activityPack.packName + (isCopy ? " KOPI" : ""),
        packTitle: activityPack.packTitle,
        packDescription: activityPack.packDescription,
        packTitle_en: activityPack.packTitle_en,
        packDescription_en: activityPack.packDescription_en,
        quests: activityPack.quests,
      };

      await axios.post(
        `${config.api.invokeUrl}/activities/packs/${activityPack.id}`,
        params
      );

      const submittedPack = { ...activityPack, activities: params.activities };

      this.setState((prevState) => ({
        activityPacks: [...prevState.activityPacks, submittedPack],
        selectedActivities: [],
        newActivityPack: {
          id: uuid(),
          activities: [],
          packName: "",
          packTitle: "",
          packDescription: "",
          packTitle_en: "",
          packDescription_en: "",
          quests: initialQuestsState(),
        },
      }));
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateActivityPack = async (activityPack, activities) => {
    const packToUpdate = { ...activityPack };
    packToUpdate.activities = activities.map((activity) => activity.id);

    try {
      const params = {
        id: packToUpdate.id,
        activities: packToUpdate.activities,
        packName: packToUpdate.packName,
        packTitle: packToUpdate.packTitle,
        packDescription: packToUpdate.packDescription,
        packTitle_en: packToUpdate.packTitle_en,
        packDescription_en: packToUpdate.packDescription_en,
        quests: packToUpdate.quests,
      };
      await axios.patch(
        `${config.api.invokeUrl}/activities/packs/${packToUpdate.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }

    const updatedActivityPacks = this.state.activityPacks.map((ap) =>
      ap.id === packToUpdate.id ? packToUpdate : ap
    );
    this.setState({ activityPacks: updatedActivityPacks });
  };

  handleDeleteActivityPack = async (id, event) => {
    event.preventDefault();
    if (window.confirm(" Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/activities/packs/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedActivityPacks = [...this.state.activityPacks].filter(
        (activityPack) => activityPack.id !== id
      );
      this.setState({ activityPacks: updatedActivityPacks });
    }
  };

  fetchActivityPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/activities/packs/`);
      const activityPacks = res.data.map((pack) => ({
        ...pack,
        quests: pack.quests || initialQuestsState(),
      }));
      this.setState({ activityPacks: activityPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchActivities = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/activities`);
      const activities = res.data;
      this.setState({ activities: activities });
    } catch (err) {
      console.log(err);
    }
  };

  handleDeselectActivity(index) {
    var selectedActivities = this.state.selectedActivities.slice();
    selectedActivities.splice(index, 1);
    this.setState({ selectedActivities });
  }

  handleActivitySelectionChange = (selectedActivities) => {
    this.setState({ selectedActivities });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newActivityPack: {
        ...this.state.newActivityPack,
        [name]: value,
      },
    });
  }

  handleQuestPointsChange = (difficultyKey, points) => {
    this.setState((prevState) => ({
      newActivityPack: {
        ...prevState.newActivityPack,
        quests: {
          ...prevState.newActivityPack.quests,
          [difficultyKey]: {
            ...prevState.newActivityPack.quests[difficultyKey],
            points: points,
          },
        },
      },
    }));
  };

  handleAddQuestRequirement = (difficultyKey) => {
    const newReq = createNewRequirement();
    this.setState((prevState) => ({
      newActivityPack: {
        ...prevState.newActivityPack,
        quests: {
          ...prevState.newActivityPack.quests,
          [difficultyKey]: {
            ...prevState.newActivityPack.quests[difficultyKey],
            requirements: [
              ...prevState.newActivityPack.quests[difficultyKey].requirements,
              newReq,
            ],
          },
        },
      },
    }));
  };

  handleRemoveQuestRequirement = (difficultyKey, reqId) => {
    this.setState((prevState) => ({
      newActivityPack: {
        ...prevState.newActivityPack,
        quests: {
          ...prevState.newActivityPack.quests,
          [difficultyKey]: {
            ...prevState.newActivityPack.quests[difficultyKey],
            requirements: prevState.newActivityPack.quests[
              difficultyKey
            ].requirements.filter((req) => req.id !== reqId),
          },
        },
      },
    }));
  };

  handleQuestRequirementChange = (difficultyKey, reqId, field, value) => {
    this.setState((prevState) => ({
      newActivityPack: {
        ...prevState.newActivityPack,
        quests: {
          ...prevState.newActivityPack.quests,
          [difficultyKey]: {
            ...prevState.newActivityPack.quests[difficultyKey],
            requirements: prevState.newActivityPack.quests[
              difficultyKey
            ].requirements.map((req) =>
              req.id === reqId
                ? {
                    ...req,
                    [field]: value,
                    ...(field === "type"
                      ? { details: createNewRequirement(value).details }
                      : {}),
                  }
                : req
            ),
          },
        },
      },
    }));
  };

  handleQuestRequirementDetailChange = (
    difficultyKey,
    reqId,
    detailField,
    value
  ) => {
    this.setState((prevState) => ({
      newActivityPack: {
        ...prevState.newActivityPack,
        quests: {
          ...prevState.newActivityPack.quests,
          [difficultyKey]: {
            ...prevState.newActivityPack.quests[difficultyKey],
            requirements: prevState.newActivityPack.quests[
              difficultyKey
            ].requirements.map((req) =>
              req.id === reqId
                ? { ...req, details: { ...req.details, [detailField]: value } }
                : req
            ),
          },
        },
      },
    }));
  };

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    await Promise.all([this.fetchActivities(), this.fetchActivityPacks()]);
    this.setState({ loading: false });
  };

  renderQuestRequirementFields = (difficultyKey, req) => {
    const selectedActivityForChoices = this.state.activities.find(
      (act) => act.id === req.details.activityId
    );

    const activityOptions = this.state.selectedActivities.map((act) => ({
      value: act.id,
      label: `${act.activityName} (${act.activityType || "Uden type"})`,
    }));

    const selectedActivityOption = activityOptions.find(
      (opt) => opt.value === req.details.activityId
    );

    // Prepare choice options if an activity is selected
    let choiceOptionsForSelect = [];
    if (
      selectedActivityForChoices &&
      selectedActivityForChoices.choices &&
      selectedActivityForChoices.choices.length > 0
    ) {
      choiceOptionsForSelect = selectedActivityForChoices.choices.map(
        (choice, index) => ({
          // Store both da and en text, or prioritize da if available
          value: JSON.stringify({
            text_da: choice.text_da,
            text_en: choice.text_en,
          }), // Store both texts as a stringified object
          label: choice.text_da || choice.text_en || `Valg ${index + 1}`, // Display text
        })
      );
    }
    // Find the currently selected choice option for the react-select component
    const currentSelectedChoiceOption = choiceOptionsForSelect.find((opt) => {
      try {
        const optValue = JSON.parse(opt.value);
        return (
          optValue.text_da === req.details.choiceText_da &&
          optValue.text_en === req.details.choiceText_en
        );
      } catch (e) {
        return false;
      }
    });

    return (
      <div key={req.id} className="box" style={{ marginBottom: "1em" }}>
        <div className="field">
          <label className="label is-small">Krav Beskrivelse (Dansk)</label>
          <div className="control">
            <input
              className="input is-small"
              type="text"
              value={req.description}
              onChange={(e) =>
                this.handleQuestRequirementChange(
                  difficultyKey,
                  req.id,
                  "description",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        <div className="field">
          <label className="label is-small">Krav Beskrivelse (Engelsk)</label>
          <div className="control">
            <input
              className="input is-small"
              type="text"
              value={req.description_en}
              onChange={(e) =>
                this.handleQuestRequirementChange(
                  difficultyKey,
                  req.id,
                  "description_en",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        <div className="field">
          <label className="label is-small">Krav Type</label>
          <div className="control">
            <div className="select is-small">
              <select
                value={req.type}
                onChange={(e) =>
                  this.handleQuestRequirementChange(
                    difficultyKey,
                    req.id,
                    "type",
                    e.target.value
                  )
                }
              >
                {REQUIREMENT_TYPES.map((rt) => (
                  <option key={rt.value} value={rt.value}>
                    {rt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {req.type === "completeActivityWithChoice" && (
          <>
            <div className="field">
              <label className="label is-small">Aktivitet</label>
              <div className="control">
                <Select
                  options={activityOptions}
                  value={selectedActivityOption}
                  onChange={(selectedOption) =>
                    this.handleQuestRequirementDetailChange(
                      difficultyKey,
                      req.id,
                      "activityId",
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  placeholder="Vælg eller søg aktivitet..."
                  isClearable
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            {selectedActivityForChoices &&
              selectedActivityForChoices.choices &&
              selectedActivityForChoices.choices.length > 0 && (
                <div className="field">
                  <label className="label is-small">Valgmulighed (tekst)</label>
                  <div className="control">
                    <Select
                      options={choiceOptionsForSelect}
                      value={currentSelectedChoiceOption}
                      onChange={(selectedChoiceOpt) => {
                        if (selectedChoiceOpt) {
                          try {
                            const choiceTexts = JSON.parse(
                              selectedChoiceOpt.value
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_da",
                              choiceTexts.text_da || ""
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_en",
                              choiceTexts.text_en || ""
                            );
                          } catch (e) {
                            console.error("Error parsing choice text:", e);
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_da",
                              ""
                            );
                            this.handleQuestRequirementDetailChange(
                              difficultyKey,
                              req.id,
                              "choiceText_en",
                              ""
                            );
                          }
                        } else {
                          this.handleQuestRequirementDetailChange(
                            difficultyKey,
                            req.id,
                            "choiceText_da",
                            ""
                          );
                          this.handleQuestRequirementDetailChange(
                            difficultyKey,
                            req.id,
                            "choiceText_en",
                            ""
                          );
                        }
                      }}
                      placeholder="Vælg påkrævet valgmulighed..."
                      isClearable
                      classNamePrefix="react-select-choice"
                    />
                  </div>
                </div>
              )}
            <div className="field">
              <label className="label is-small">Antal gange</label>
              <div className="control">
                <input
                  className="input is-small"
                  type="number"
                  min="1"
                  value={req.details.count || 1}
                  onChange={(e) =>
                    this.handleQuestRequirementDetailChange(
                      difficultyKey,
                      req.id,
                      "count",
                      parseInt(e.target.value)
                    )
                  }
                />
              </div>
            </div>
          </>
        )}
        {req.type === "completeActivityOnce" && (
          <div className="field">
            <label className="label is-small">Aktivitet</label>
            <div className="control">
              <Select
                options={activityOptions}
                value={selectedActivityOption}
                onChange={(selectedOption) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "activityId",
                    selectedOption ? selectedOption.value : ""
                  )
                }
                placeholder="Vælg eller søg aktivitet..."
                isClearable
                classNamePrefix="react-select"
              />
            </div>
          </div>
        )}
        {req.type === "earnPoints" && (
          <div className="field">
            <label className="label is-small">Point Antal</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                value={req.details.amount || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "amount",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "earnCO2" && (
          <div className="field">
            <label className="label is-small">Kg CO2</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                step="0.1"
                value={req.details.amount || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "amount",
                    parseFloat(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "reachStreak" && (
          <div className="field">
            <label className="label is-small">Antal Dage Streak</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                min="1"
                value={req.details.days || ""}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "days",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        {req.type === "answerQuizCorrectly" && (
          <div className="field">
            <label className="label is-small">Antal korrekte quiz svar</label>
            <div className="control">
              <input
                className="input is-small"
                type="number"
                min="1"
                value={req.details.count || 1}
                onChange={(e) =>
                  this.handleQuestRequirementDetailChange(
                    difficultyKey,
                    req.id,
                    "count",
                    parseInt(e.target.value)
                  )
                }
              />
            </div>
          </div>
        )}
        <button
          type="button"
          className="button is-danger is-small"
          onClick={() =>
            this.handleRemoveQuestRequirement(difficultyKey, req.id)
          }
        >
          Fjern Krav
        </button>
      </div>
    );
  };

  render() {
    return !this.state.loading ? (
      <>
        <p className="subtitle is-5">Tilføj og fjern Aktivitetspakker</p>
        <br />
        <div className="columns is-multiline is-flex-direction-column">
          <div className="column is-full">
            <form
              onSubmit={(event) =>
                this.handleAddActivityPack(this.state.newActivityPack, event)
              }
            >
              <div className="control">
                <input
                  className="input is-medium"
                  type="text"
                  name="packName"
                  placeholder="Indtast navn"
                  required
                  value={this.state.newActivityPack.packName}
                  onChange={this.handleInputChange}
                />
                <input
                  className="input is-medium"
                  type="text"
                  name="packTitle"
                  placeholder="Indtast title (synlig for brugere)"
                  required
                  value={this.state.newActivityPack.packTitle}
                  onChange={this.handleInputChange}
                />
                <input
                  className="input is-medium"
                  type="text"
                  name="packTitle_en"
                  placeholder="Indtast title ENGELSK (synlig for brugere)"
                  required
                  value={this.state.newActivityPack.packTitle_en}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="packDescription"
                  className="textarea"
                  placeholder="Beskrivelse"
                  value={this.state.newActivityPack.packDescription}
                  onChange={this.handleInputChange}
                />
                <textarea
                  name="packDescription_en"
                  className="textarea"
                  placeholder="Beskrivelse engelsk"
                  value={this.state.newActivityPack.packDescription_en}
                  onChange={this.handleInputChange}
                />
                <div className="column is-flex is-flex-direction-row">
                  <div className="column is-half">
                    Vælg aktiviteter (til pakken generelt)
                    <FilteredMultiSelect
                      onChange={this.handleActivitySelectionChange}
                      options={this.state.activities}
                      selectedOptions={this.state.selectedActivities}
                      textProp="activityName"
                      valueProp="id"
                      className="activity-selector"
                      placeholder="søg"
                      buttonText="vælg"
                    />
                    {this.state.selectedActivities.length === 0 && (
                      <p>(intet valgt endnu)</p>
                    )}
                    {this.state.selectedActivities.length > 0 && (
                      <ul>
                        {this.state.selectedActivities.map((activity, i) => (
                          <li key={activity.id}>
                            {`${activity.activityName} ${
                              activity.category || ""
                            }`}
                            <button
                              type="button"
                              onClick={() => this.handleDeselectActivity(i)}
                            >
                              ×
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                <div className="box">
                  <h3 className="title is-5">Quests</h3>
                  {QUEST_DIFFICULTIES.map((diff) => (
                    <div
                      key={diff.key}
                      className="box"
                      style={{
                        border: "1px solid #ddd",
                        padding: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <h4 className="title is-6">{diff.label} Quest</h4>
                      <div className="field">
                        <label className="label">
                          Point for {diff.label} Quest
                        </label>
                        <div className="control">
                          <input
                            className="input"
                            type="number"
                            value={
                              this.state.newActivityPack.quests[diff.key].points
                            }
                            onChange={(e) =>
                              this.handleQuestPointsChange(
                                diff.key,
                                e.target.value
                              )
                            }
                            placeholder={`Point for ${diff.label}`}
                          />
                        </div>
                      </div>
                      <h5 className="subtitle is-6">
                        Krav (
                        {
                          this.state.newActivityPack.quests[diff.key]
                            .requirements.length
                        }
                        )
                      </h5>
                      {this.state.newActivityPack.quests[
                        diff.key
                      ].requirements.map((req) =>
                        this.renderQuestRequirementFields(diff.key, req)
                      )}
                      <button
                        type="button"
                        className="button is-link is-small"
                        onClick={() => this.handleAddQuestRequirement(diff.key)}
                      >
                        Tilføj Krav til {diff.label}
                      </button>
                    </div>
                  ))}
                </div>

                <button type="submit" className="button is-primary is-medium">
                  Tilføj Aktivitetspakke
                </button>
              </div>
            </form>
          </div>
          <div className="column">
            <div className="tile is-ancestor ">
              <div className="tile is-parent flex-wrap">
                {this.state.activityPacks.map((activityPack) => (
                  <ActivityPack
                    handleUpdateActivityPack={this.handleUpdateActivityPack}
                    handleDeleteActivityPack={this.handleDeleteActivityPack}
                    handleAddActivityPack={this.handleAddActivityPack}
                    activityPack={activityPack}
                    activities={this.state.activities}
                    key={activityPack.id}
                    isAdmin={true}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <p>Loading activity packs and activities...</p>
    );
  }
}
